import { Component, Host, Prop, h } from '@stencil/core';
import { v4 as uuidv4 } from 'uuid';

@Component({
  tag: 'anchor-help-box',
  styleUrl: 'help-box.scss',
  shadow: true,
})
export class HelpBox {
  /**
   *  Give this instance of help-box a custom ID, or keep the default.
   */
  @Prop({}) uuid: string = uuidv4();

  render() {
    return (
      <Host>
        <div id={this.uuid} class={`anchor-c-help-box`}>
          <div class="anchor-c-help-box__content">
            <slot name="icon"></slot>
            <slot name="header"></slot>
            <slot></slot>
            <slot name="link"></slot>
          </div>
        </div>
      </Host>
    );
  }
}
